<template>
  <!-- MODAL -->
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6">
              <!-- Conteiner de título e botão de fechar -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">{{ title }}</h2>
                <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <!-- Formulário principal com flex -->
              <div class="mt-4">
                <form class="flex flex-wrap gap-4" @submit="sendData" method="POST">
                  <div
                    v-for="(input, index) in inputsList"
                    :key="index"
                    class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2"
                  >
                    <label
                      :for="input.name"
                      class="block text-sm font-medium leading-6 text-gray-900"
                    >
                      {{ input.label }}
                    </label>

                    <!-- Select -->
                    <select
                      v-if="input.type === 'select'"
                      v-model="data[input.name]"
                      :id="input.name"
                      :name="input.name"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    >
                      <option value="">Selecione uma opção</option>
                      <option
                        v-for="(opt, i) in input.options"
                        :key="i"
                        :value="opt"
                      >
                        {{ opt }}
                      </option>
                    </select>

                    <!-- Textarea -->
                    <textarea
                      v-else-if="input.type === 'textarea'"
                      v-model="data[input.name]"
                      :id="input.name"
                      :name="input.name"
                      rows="3"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    ></textarea>

                    <!-- Input normal -->
                    <input
                      v-else
                      v-model="data[input.name]"
                      :id="input.name"
                      :name="input.name"
                      :type="input.type"
                      :step="input.step || null"
                      :readonly="input.readonly || false"
                      :required="true"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                   <!-- Campos dinâmicos gerados por extraInputs -->
                    <div v-if="extraInputs" class="flex gap-4 flex-wrap">
                      <!-- Iterar sobre cada extraInput para gerar o campo -->
                      <div v-for="(input, index) in extraInputs" :key="index" class="flex-1 min-w-[200px]">
                        <label :for="input.name" class="block text-sm font-medium leading-6 text-gray-900">{{ input.label }}</label> 
                        <input
                          v-model="extraObect[input.name]"
                          :id="input.name"
                          :name="input.name"
                          :type="input.type"
                          :required="false"
                          class="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>        

                  <!-- Botão de adicionar novo conjunto de campos dinâmicos -->
                  <div v-if="extraInputs" class="w-full">
                    <button @click.prevent="addExtraField" type="button" class="mt-2 w-full flex justify-center rounded-md bg-green-500 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-400">Adicionar {{ extraInputName }}</button>
                  </div>
                  <!-- Botão de enviar formulário -->
                   <div v-if="Object.keys(data.extraFields).length">
                    <DynamicTable
                      :extraFields=" this.data.extraFields"
                      @remove-item="removeExtraField"
                    />
                   </div>
                  <div class="w-full">
                    <button type="submit" class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500">Cadastrar</button>
                  </div>
                </form>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import DynamicTable from './DynamicTable.vue';

  export default {
    name: 'CommonForm',
    async created(){
        
    },
    props: {
      inputsList: {
        type: Array,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      open: {
        type: Boolean,
        required: true
      },
      extraInputs:
      {
        type: Array,
        required: false
      },
      resetFormData:{
        type: Boolean,
        required:true
      },
      extraInputName: {
        type: String,
        required: false
      }
    },  
    watch: {
      resetFormData(newValue) { 
        if(newValue == true){
          this.data = {
            extraFields:[]
          }
        }
      }
    }, 
    data() {
      return {
        data:
        {  
          extraFields:[]
        },
        extraObect:{    
          
        },
      };
    },
    methods: {
      sendData(e) {
        e.preventDefault();
        this.$emit('data', this.data);
      },
      closeDialog() {
        this.$emit('update-open', false);  // Emite um evento para o componente pai alterar a prop "open"
      },
      addExtraField() {
        this.data.extraFields.push(this.extraObect); // Adiciona o novo objeto ao array
        this.extraObect = {}
      },
      removeExtraField(index) {
        this.data.extraFields.splice(index, 1); // Remove o campo extra do array
      },
    },
    components:{
      Dialog,
      DialogPanel, 
      TransitionChild, 
      TransitionRoot,
      DynamicTable
    },
  }
</script>